import {
  Card,
  Chip,
  IconButton,
  Modal,
  Stack,
  Typography,
  Grid as Grid,
  Box,
  useTheme,
  useMediaQuery,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import { ArrowUpward } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
const ResumeBuilderTutorial = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_RESUME_BUILDER_HEADER = English.ResumeBuilder.TEXT_RESUME_BUILDER_HEADER,
    TEXT_QUICKLY_GENERATE_AND = English.ResumeBuilder.TEXT_QUICKLY_GENERATE_AND,
    TEXT_SAVE_UP_TO_5 = English.ResumeBuilder.TEXT_SAVE_UP_TO_5,
    TEXT_TAP_ANYWHERE = English.ResumeBuilder.TEXT_TAP_ANYWHERE
  } = LanguageData || {};

  const userResumes = [
    {
      id: 483,
      resumePdf:
        "https://biappstoragetest2.blob.core.windows.net/userprofiles/8/Resume_20250522102914.pdf",
      userId: 8,
      userName: "Tejashree Bhuse",
      resumeDate: "2025-05-22T04:00:17",
      title: "Test 1",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-22T10:30:17.593",
      modifiedBy: 8,
      dateModified: "2025-05-22T10:30:17.593",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    },
    {
      id: 484,
      resumePdf:
        "https://biappstoragetest2.blob.core.windows.net/userprofiles/8/Resume_20250522103133.pdf",
      userId: 8,
      userName: "Tejashree Bhuse",
      resumeDate: "2025-05-22T04:02:17",
      title: "Test2",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-22T10:32:17.71",
      modifiedBy: 8,
      dateModified: "2025-05-22T10:32:17.71",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    },
    {
      id: 488,
      resumePdf:
        "https://biappstoragetest2.blob.core.windows.net/userprofiles/8/Resume_20250523114338.pdf",
      userId: 8,
      userName: "Tejashree Bhuse",
      resumeDate: "2025-05-23T05:14:17",
      title: "Test3",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-23T11:44:17.653",
      modifiedBy: 8,
      dateModified: "2025-05-23T11:44:17.653",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    },
    {
      id: 489,
      resumePdf:
        "https://biappstoragetest2.blob.core.windows.net/userprofiles/8/Resume_20250523114515.pdf",
      userId: 8,
      userName: "Tejashree Bhuse",
      resumeDate: "2025-05-23T05:15:51",
      title: "Testing qw",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-23T11:45:52",
      modifiedBy: 8,
      dateModified: "2025-05-23T11:45:52",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    },
    {
      id: 494,
      resumePdf:
        "https://biappstoragetest2.blob.core.windows.net/userprofiles/8/Resume_20250526082949.pdf",
      userId: 8,
      userName: "Tejashree Bhuse",
      resumeDate: "2025-05-26T02:00:11",
      title: " No",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-26T08:30:12.063",
      modifiedBy: 8,
      dateModified: "2025-05-26T08:30:12.063",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    }
  ];
  const renderResumeList = (itemList) => {
    return itemList?.map((item, index) => (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
        <ListItem
          alignItems="flex-start"
          sx={{ m: 0, p: 0 }}
          key={index.toString()}
          secondaryAction={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          }>
          <ListItemButton alignItems="flex-start" sx={{ m: 0 }}>
            <ListItemText
              sx={{ m: 0, alignItems: "flex-start" }}
              primary={
                <Typography variant="body1" maxWidth={"430px"} noWrap>
                  {item?.title}
                </Typography>
              }
              secondary={new Date(item?.resumeDate).toLocaleDateString(undefined, {
                month: "short",
                day: "numeric"
              })}
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box
            className="main-content-Box"
            sx={{ p: isSmallScreen ? 2 : 3, pt: 2, backgroundColor: "transparent" }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_RESUME_BUILDER_HEADER}</Typography>
                  <Typography variant="subtitle1">{TEXT_QUICKLY_GENERATE_AND}</Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}> {TEXT_TAP_ANYWHERE}</span>
                  </Typography>
                </Stack>
              </Box>
            )}
            {props.tutorialIndex === 2 && (
              <>
                <Card sx={{ p: 2, mt: { xs: 4.5, md: 5 } }}>
                  <List disablePadding>
                    <Stack gap={1}>{renderResumeList(userResumes)}</Stack>
                  </List>
                </Card>
                <Stack sx={{ display: "flex", alignItems: "center", pt: 2 }}>
                  <Stack
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "white"
                    }}>
                    <ArrowUpward />
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      {TEXT_SAVE_UP_TO_5}
                    </Typography>
                  </Stack>
                </Stack>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ResumeBuilderTutorial;
